import { render, staticRenderFns } from "./SortableDocumentList.vue?vue&type=template&id=03f8fede"
import script from "./SortableDocumentList.vue?vue&type=script&lang=js"
export * from "./SortableDocumentList.vue?vue&type=script&lang=js"
import style0 from "./SortableDocumentList.vue?vue&type=style&index=0&id=03f8fede&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports